<div class="container mt-2 mb-5" style="
    width: 100% !important;
    padding: 0 0.35rem 0 0.35rem !important ;
    max-width: max-content;
  ">
  <div style="overflow: hidden" class="mb-3">
    <h4 class="float-left mb-0" style="margin-top: 8px" i18n>Meus Pedidos</h4>
    <table class="float-right form-group mb-0">
      <tr>
        <td class="align-middle">
          <span class="info1">Status:&nbsp;</span>
        </td>
        <td>
          <div class="form-group mb-0">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label routerLink="/pedidos" i18n-routerLink="/orders" [queryParams]="{ page: 'ABERTO' }"
                [class.active]="page == 'ABERTO'" class="btn btn-primary" i18n>
                <input type="radio" name="options" id="option1" autocomplete="off" checked />
                DIGITAÇÃO
              </label>
              <label *ngIf="
                  SITE.salvaCheckout && this.initProvider.usuario.integra_pedido
                " routerLink="/pedidos" i18n-routerLink="/orders" [queryParams]="{ page: 'SALVO' }"
                [class.active]="page == 'SALVO'" class="btn btn-primary" i18n>
                <input type="radio" name="options" id="option1" autocomplete="off" checked />
                ORÇAMENTO
              </label>
              <label routerLink="/pedidos" i18n-routerLink="/orders" [queryParams]="{ page: 'EM_ANDAMENTO' }"
                [class.active]="page == 'EM_ANDAMENTO'" class="btn btn-primary" i18n>
                <input type="radio" name="options" id="option2" autocomplete="off" />
                ANDAMENTO
              </label>
              <label routerLink="/pedidos" i18n-routerLink="/orders" [queryParams]="{ page: 'CONCLUIDO' }"
                [class.active]="page == 'CONCLUIDO'" class="btn btn-primary" i18n>
                <input type="radio" name="options" id="option3" autocomplete="off" />
                CONCLUÍDO
              </label>
              <label routerLink="/pedidos" i18n-routerLink="/orders" [queryParams]="{ page: 'TODOS' }"
                [class.active]="page == 'TODOS'" class="btn btn-primary" i18n>
                <input type="radio" name="options" id="option4" autocomplete="off" />
                TODOS
              </label>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <form (ngSubmit)="onSubmitSearch()" [formGroup]="formSearch" class="formSearch">
    <div class="row">
      <div class="col-lg-3 data-col">
        <div class="form-group">
          <label i18n>Data</label>
          <input type="text" class="form-control form-control-sm" bsDaterangepicker formControlName="data"
            placement="bottom left" [bsConfig]="{
              isAnimated: true,
              dateInputFormat: 'DD-MM-YYYY',
              ranges: ranges
            }" />
        </div>
      </div>
      <div *ngIf="isGestor" class="col-lg-4">
        <div class="form-group">
          <label i18n>Usuário</label>
          <input [(ngModel)]="typingUsuario" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
            [typeahead]="usuarios" typeaheadOptionField="nome" isAnimated="true"
            (typeaheadOnSelect)="onSelectUsuario($event)" (typeaheadNoResults)="typeaheadNoResultsUsuario($event)"
            id="usuario" autocomplete="off" class="form-control form-control-sm" />
        </div>
      </div>
      <div class="col-lg-4 cliente-filter">
        <div class="form-group">
          <label>{{ SITE.labelCliente }}</label>
          <input [(ngModel)]="typingCliente" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
            [typeahead]="clientes" typeaheadOptionField="{{ 'nome' }}" isAnimated="true"
            (typeaheadOnSelect)="onSelectCliente($event)" (typeaheadNoResults)="typeaheadNoResults($event)" id="cliente"
            autocomplete="off" class="form-control form-control-sm" />
        </div>
      </div>
      <div class="col-lg-3 numero-pedido-input">
        <div class="form-group">
          <label i18n>Número do pedido</label>
          <input class="form-control form-control-sm" formControlName="pedido" />
        </div>
      </div>
      <div *ngIf="page != 'ABERTO' && page != 'TODOS' && page != 'SALVO'" class="col-lg-3 status-erp-col">
        <div class="form-group">
          <label i18n>Status ERP</label>
          <select name="statusERP" formControlName="statusERP" class="form-control form-control-sm">
            <option value=""></option>
            <option *ngFor="let s of statusERPs" value="{{ s }}">
              {{ s }}
            </option>
          </select>
        </div>
      </div>
      <!-- <div class="col-lg-3 numero-pedido-input">
        <div class="form-group">
          <label i18n>Número do pedido</label>
          <input [(ngModel)]="typingCliente" [ngModelOptions]="{ standalone: true }" [typeaheadAsync]="true"
            [typeahead]="clientes" typeaheadOptionField="{{ 'nome' }}" isAnimated="true"
            (typeaheadOnSelect)="onSelectCliente($event)" (typeaheadNoResults)="typeaheadNoResults($event)" id="cliente"
            autocomplete="off" class="form-control form-control-sm" disabled />
        </div>
      </div> -->
      <div class="col-lg-1">
        <div class="form-group">
          <button id="btnFormSearch" class="btn btn-sm btn-secondary" style="margin-top: 22px">
            <i class="{{ SITE ? SITE.iconSearch : '' }}"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-lg-12">
      <div *ngIf="empty" class="row mt-3">
        <div class="col-lg-6 offset-lg-3 text-center">
          <h5 i18n>Nenhum item encontrado!</h5>
          <img src="assets/empty.png" class="img-fluid" />
        </div>
      </div>
      <div *ngIf="!empty" class="table-responsive">
        <table *ngIf="page == 'ABERTO' || page == 'SALVO'" class="table table-hover table-sm">
          <thead class="thead-pedidos">
            <tr>
              <th scope="col" i18n>Usuário</th>
              <th scope="col" i18n>Data do pedido</th>
              <th scope="col" i18n>Pedido</th>
              <th scope="col">{{ SITE.labelCliente }}</th>
              <th scope="col">{{ SITE.labelFilial }}</th>
              <th scope="col">{{ SITE.labelTabela }}</th>
              <th scope="col">Status</th>
              <!-- <th scope="col" i18n>Aprovação Cliente</th> -->
              <th *ngIf="
                  SITE.precoDivergenteTabelaMin != null &&
                  SITE.precoDivergenteTabelaIdeal != null
                " scope="col" i18n>
                Preço divergente
              </th>
              <th scope="col" i18n>Itens</th>
              <th scope="col" i18n>R$&nbsp;Valor</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidos" [class.table-warning]="
                p.integracaoError || p.integracaoMessage !== null
              ">
              <td class="align-middle" data-label="Usuário">
                <button *ngIf="p.integracaoError || p.integracaoMessage !== null" class="btn btn-warning"
                  style="padding: 2px !important" tooltip="{{ p.integracaoMessage }}"
                  (click)="copiaErrorMsg(p.integracaoMessage)">
                  <i class="icofont-warning"></i>
                </button>
                <button *ngIf="p.salvoCheckout" class="btn btn-success" style="padding: 2px !important"
                  tooltip="Pedido salvo!">
                  <i class="icofont-check"></i>
                </button>
                {{ p.usuario.id }} - {{ p.usuario.nome }}
              </td>
              <td class="align-middle data-adjust" data-label="Data">
                {{ p.data }}
              </td>
              <td class="align-middle" data-label="Código">
                <div style="font-size: 0.8rem !important" *ngFor="let c of p.clientes; let i = index">
                  {{ c.numero_pedido }}
                </div>
              </td>

              <td class="align-middle" data-label="Cliente">
                <div *ngFor="let pc of p.clientes">
                  {{ pc.cliente[SITE.identificacaoCliente] }} -
                  {{ pc.cliente.nome }}
                </div>
              </td>
              <td class="align-middle" data-label="Filial">
                {{ p.filial.codigo }} - {{ p.filial.descricao }}
              </td>
              <td class="align-middle" data-label="Tabela">
                {{ p.tabela.codigo }} - {{ p.tabela.descricao }}
              </td>
              <td class="align-middle">
                <a href="javascript:void(0);" data-toggle="modal" data-target="#pedidoModalInfo"
                  (click)="showPedidoFinalizado(p)" title="Informações" i18n-title>{{
                  p.infos
                  ? p.infos.length > 0
                  ? p.infos[p.infos.length - 1].statusDescricao
                  : ""
                  : ""
                  }}</a>
              </td>
              <!-- <td class="align-middle" data-label="Aprovação Cliente">
                <div
                  *ngIf="p.clientes.length > 1; else elseBlockAprvCli"
                  class="dropdown"
                >
                  <a
                    href="#"
                    id="dropdownMenuAprovaCliente"
                    data-toggle="dropdown"
                    [innerHtml]="
                      pedidoService.getClienteAprovadoDescr(p.clientes)
                    "
                  ></a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuAprovaCliente"
                    style="cursor: pointer"
                  >
                    <a
                      *ngFor="let pc of p.clientes"
                      (click)="getLinkAprovaCliente(p, pc.id)"
                      class="dropdown-item"
                    >
                      {{ pc.cliente[SITE.identificacaoCliente] }} -
                      {{ pc.cliente.nome }}
                      <span *ngIf="pc.aprovado" style="color: green"
                        ><b>- OK</b></span
                      >
                    </a>
                  </div>
                </div>
                <ng-template #elseBlockAprvCli>
                  <a
                    (click)="getLinkAprovaCliente(p, p.clientes[0].id)"
                    [innerHtml]="
                      pedidoService.getClienteAprovadoDescr(p.clientes)
                    "
                    style="cursor: pointer"
                  ></a>
                </ng-template>
              </td> -->
              <td *ngIf="
                  SITE.precoDivergenteTabelaMin != null &&
                  SITE.precoDivergenteTabelaIdeal != null
                " class="align-middle" data-label="Itens">
                <span *ngIf="p.precoDivergenteStatus == 2; else elsePrecoDiv"
                  tooltip="Aguarde aprovação do administrador" i18n-tooltip style="color: orange"><b
                    i18n>PENDENTE</b></span>
                <ng-template #elsePrecoDiv>
                  <span style="color: blue"><b i18n>APROVADO</b></span>
                </ng-template>
              </td>
              <td class="align-middle" data-label="Itens">
                {{ p.quantidade }}
              </td>
              <td class="align-middle money-green" data-label="R$ Valor" i18n>
                R$ {{ p.total | currency : "BRL" : "" }}
              </td>
              <td class="align-middle">
                <div class="btn-group">
                  <button (click)="showPedido(p)" data-toggle="modal" data-target="#pedidoModal" title="Visualizar"
                    i18n-title class="btn btn-outline-primary buttonLeft">
                    <i class="icofont-search-document"></i>
                  </button>
                  <button [disabled]="this.pedidoService.allowDelete === null"
                    [class]="page == 'TODOS' ? 'del-btn' : ''" (click)="confirmDel($event, p)"
                    *ngIf="!securityService.isPainel()" data-toggle="modal" data-target="#confirmDelModal"
                    title="Excluir" i18n-title class="btn btn-outline-primary buttonMiddle">
                    <i class="icofont-trash"></i>
                  </button>
                  <!-- <button [class]="page == 'TODOS' ? 'del-btn':''" (click)="gerar(p.itens)" *ngIf="!securityService.isPainel()"
                    title="Excluir" i18n-title class="btn btn-outline-primary buttonMiddle">
                    print
                  </button> -->

                  <div *ngIf="
                      p.clientes && p.clientes.length > 1;
                      else elseBlockPrint1
                    " class="dropdown">
                    <button class="btn btn-outline-primary dropdown-toggle buttonMiddle" (click)="printPedidoPdf(p)"
                      style="min-height: -webkit-fill-available; height: 100%" id="dropdownMenuLink"
                      data-toggle="dropdown" title="Imprimir" [class.spinner]="loadPdf" [disabled]="loadPdf" i18n-title>
                      <i class="icofont-printer"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="cursor: pointer">
                      <a *ngFor="let pc of p.clientes" (click)="printPedidoPdf(pc)" class="dropdown-item">
                        {{ pc.cliente[SITE.identificacaoCliente] }} -
                        {{ pc.cliente.nome }}
                      </a>
                    </div>
                    <!-- <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="cursor: pointer">
                      <a *ngFor="let pc of p.clientes" (click)="printPedidoPdfServer(pc.id)" class="dropdown-item">
                        {{ pc.cliente[SITE.identificacaoCliente] }} -
                        {{ pc.cliente.nome }}
                      </a>
                    </div> -->
                  </div>
                  <ng-template #elseBlockPrint1>
                    <button class="btn btn-outline-primary buttonMiddle tes" (click)="printPedidoPdf(p)"
                      title="Imprimir" i18n-title [class.spinner]="loadPdf" [disabled]="loadPdf">
                      <i class="icofont-printer"></i>
                    </button>
                  </ng-template>
                  <button *ngIf="page !== 'TODOS' && !securityService.isPainel()" (click)="selectPedido(p)"
                    [disabled]="p.integracaoError" title="Editar" i18n-title
                    class="btn btn-outline-primary buttonMiddle">
                    <i class="icofont-ui-edit"></i>
                  </button>
                  <div *ngIf="excel.length > 1; else elseBlockExcel" class="dropdown">
                    <button class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                      style="min-height: -webkit-fill-available; height: 100%" id="dropdownMenuLinkExcel"
                      data-toggle="dropdown" title="Excel" [class.spinner]="loadPdf" [disabled]="loadPdf" i18n-title>
                      <i class="icofont-table"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkExcel" style="cursor: pointer">
                      <a *ngFor="let e of excel" (click)="printPedidoExcel(p, e)" class="dropdown-item">
                        {{ e }}
                      </a>
                    </div>
                  </div>
                  <ng-template #elseBlockExcel>
                    <button class="btn btn-outline-primary buttonMiddle excel-btn-digitacao"
                      (click)="printPedidoExcel(p, excel)" title="Excel" i18n-title>
                      <i class="icofont-table"></i>
                    </button>
                  </ng-template>
                  <!-- <button class="btn btn-outline-primary buttonMiddle excel-btn-digitacao" (click)="printPedidoExcel(p)"
                    title="Excel" i18n-title>
                    <i class="icofont-table"></i>
                  </button> -->
                  <button title="Orçamento" class="btn btn-outline-primary buttonMiddle orcamento-pedido"
                    (click)="selectPedidoOrcamento(p)">
                    <mat-icon>currency_exchange</mat-icon>
                  </button>
                  <button (click)="download(p)" title="Download" i18n-title
                    class="btn btn-outline-primary buttonMiddle download-btn" [class.spinner]="loadImgs"
                    [disabled]="loadImgs">
                    <mat-icon>download</mat-icon>
                  </button>
                  <div *ngIf="
                      p.clientes && p.clientes.length > 1;
                      else ElseBlockCopy1
                    " class="dropdown">
                    <button class="btn btn-outline-primary dropdown-toggle buttonMiddle copia-pedido"
                      style="min-height: -webkit-fill-available; height: 100%" id="dropdownMenuLink"
                      data-toggle="dropdown" title="Copiar" [class.spinner]="loadPdf" [disabled]="loadPdf" i18n-title>
                      <i class="icofont-copy"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="cursor: pointer">
                      <a *ngFor="let pc of p.clientes; index as i" (click)="copyOrder(p, i)" class="dropdown-item">
                        {{ pc.cliente[SITE.identificacaoCliente] }} -
                        {{ pc.cliente.nome }}
                      </a>
                    </div>
                  </div>
                  <ng-template #ElseBlockCopy1>
                    <button class="btn btn-outline-primary buttonMiddle copia-cabecalho" (click)="copyOrder(p, 0)"
                      title="Copiar" i18n-title [class.spinner]="loadPdf" [disabled]="loadPdf">
                      <i class="icofont-copy"></i>
                    </button>
                  </ng-template>
                  <button *ngIf="!this.initProvider.inicializaPedido" (click)="redirectCopyPedido(p)"
                    title="Copiar cabeçalho" i18n-title class="btn btn-outline-primary buttonMiddle copia-cabecalho">
                    <mat-icon>copy_all</mat-icon>
                  </button>
                  <button (click)="toHome()" title="Home" *ngIf="page !== 'ABERTO'"
                    class="btn btn-outline-primary buttonRight">
                    <mat-icon>home</mat-icon>
                  </button>
                  <button *ngIf="page != 'TODOS' && !securityService.isPainel()" (click)="selectPedidoCheckout(p)"
                    [disabled]="p.integracaoError" title="Finalizar" i18n-title class="btn btn-outline-primary">
                    <i class="icofont-check-circled"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table *ngIf="
            page == 'EM_ANDAMENTO' || page == 'CONCLUIDO' || page == 'TODOS'
          " class="table table-hover table-sm">
          <thead class="thead-pedidos">
            <tr>
              <th scope="col" i18n>Pedido</th>
              <th scope="col" i18n>Usuário</th>
              <th scope="col" i18n>Data do Pedido</th>
              <th scope="col" i18n>Tipo</th>
              <th scope="col">{{ SITE.labelCliente }}</th>
              <th scope="col">{{ SITE.labelFilial }}</th>
              <th scope="col">{{ SITE.labelTabela }}</th>
              <th scope="col" i18n>Status</th>
              <th scope="col" i18n>Itens</th>
              <th scope="col" i18n>R$&nbsp;Valor</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidos">
              <td class="align-middle">{{ p.numero_pedido }}</td>
              <td class="align-middle">
                {{ p.usuario.id }} - {{ p.usuario.nome }}
              </td>
              <td class="align-middle data-adjust">
                {{ p.data }}
              </td>
              <td class="align-middle data-adjust">
                {{ p.tipo.descricao }}
              </td>
              <td class="align-middle">
                {{ p.cliente[SITE.identificacaoCliente] }} -
                {{ p.cliente.nome }}
              </td>
              <td class="align-middle">
                {{ p.filial.codigo }} - {{ p.filial.descricao }}
              </td>
              <td class="align-middle">
                {{ p.tabela.codigo }} - {{ p.tabela.descricao }}
              </td>
              <td *ngIf="page == 'TODOS'" class="align-middle">
                <a href="javascript:void(0);" data-toggle="modal" data-target="#pedidoModalInfo" (click)="showPedido(p)"
                  title="Informações" i18n-title>{{
                  p.infos && p.infos.length > 0
                  ? p.infos[p.infos.length - 1].statusDescricao
                  : ""
                  }}</a>
              </td>
              <td *ngIf="page != 'TODOS'" class="align-middle">
                <a href="javascript:void(0);" data-toggle="modal" data-target="#pedidoModalInfo"
                  (click)="showPedidoFinalizado(p)" title="Informações" i18n-title>{{
                  p.infos && p.infos.length > 0
                  ? p.infos[p.infos.length - 1].statusDescricao
                  : ""
                  }}</a>
              </td>
              <td class="align-middle">{{ p.quantidade }}</td>
              <td class="align-middle money-green" i18n>
                R$ {{ p.total | currency : "BRL" : "" }}
              </td>
              <td class="align-middle">
                <div class="btn-group">
                  <button *ngIf="
                      page != 'TODOS' &&
                      p.infos &&
                      p.infos.length > 0 &&
                      p.infos[p.infos.length - 1].statusDescricao !==
                        'AGUARDANDO_PAGAMENTO'
                    " (click)="showPedido(p)" data-toggle="modal" data-target="#pedidoModalFinalizado"
                    title="Visualizar" i18n-title class="btn btn-outline-primary buttonLeft">
                    <i class="icofont-search-document"></i>
                  </button>
                  <button *ngIf="
                      page != 'TODOS' &&
                      p.infos &&
                      p.infos.length > 0 &&
                      p.infos[p.infos.length - 1].statusDescricao ===
                        'AGUARDANDO_PAGAMENTO'
                    " (click)="gerarLinkPagamento(p)" data-toggle="modal" data-target="#pixModal"
                    title="Gerar Pagamento" i18n-title class="btn btn-outline-primary buttonLeft">
                    <mat-icon>attach_money</mat-icon>
                  </button>

                  <button *ngIf="page == 'TODOS'" (click)="showPedido(p)" data-toggle="modal"
                    data-target="#pedidoModalFinalizado" title="Visualizar" i18n-title
                    class="btn btn-outline-primary buttonLeft">
                    <i class="icofont-search-document"></i>
                  </button>
                  <button (click)="download(p)" title="Download" i18n-title
                    class="btn btn-outline-primary buttonMiddle download-btn" [class.spinner]="loadImgs"
                    [disabled]="loadImgs">
                    <mat-icon>download</mat-icon>
                  </button>
                  <!-- <button
                    *ngIf="initProvider.usuario.integra_pedido"
                    (click)="selectPedido(p)"
                    title="Editar"
                    i18n-title
                    class="btn btn-outline-primary buttonMiddle"
                  >
                    <i class="icofont-ui-edit"></i>
                  </button> -->
                  <div *ngIf="excel.length > 1; else elseBlockExcel" class="dropdown">
                    <button class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                      style="min-height: -webkit-fill-available; height: 100%" id="dropdownMenuLinkExcel"
                      data-toggle="dropdown" title="Excel" [class.spinner]="loadPdf" [disabled]="loadPdf" i18n-title>
                      <i class="icofont-table"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLinkExcel" style="cursor: pointer">
                      <a *ngFor="let e of excel" (click)="printPedidoExcel(p, e)" class="dropdown-item">
                        {{ e }}
                      </a>
                    </div>
                  </div>
                  <ng-template #elseBlockExcel>
                    <button class="btn btn-outline-primary buttonMiddle excel-btn-digitacao"
                      (click)="printPedidoExcel(p, excel)" title="Excel" i18n-title>
                      <i class="icofont-table"></i>
                    </button>
                  </ng-template>
                  <button class="btn btn-outline-primary buttonMiddle rastreio-btn" (click)="redirectToRastreio(p)"
                    title="Rastreio" i18n-title>
                    <mat-icon>local_shipping</mat-icon>
                  </button>
                  <!-- <button
                    [disabled]="!p.documentos || p.documentos.length < 0"
                    class="btn btn-outline-primary buttonMiddle"
                    title="Rastreio"
                    i18n-title
                  >
                    <mat-icon>receipt</mat-icon>
                  </button> -->
                  <div *ngIf="
                      p.documentos && p.documentos.length > 1;
                      else elseBlockPrint1
                    " class="dropdown nfe-btn">
                    <button class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                      style="min-height: -webkit-fill-available" id="dropdownMenuLink" data-toggle="dropdown"
                      title="Nota fiscal" [class.spinner]="loadNota" [disabled]="!p.documentos || p.documentos.length ===0 || loadNota" i18n-title>
                      <img src="assets/nfe-icon.svg" class="normal-icon" width="24" />
                      <img src="assets/nfe-icon-hover.svg" class="hover-icon" width="24" />
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuLink" style="cursor: pointer">
                      <a *ngFor="let p of p.documentos" (click)="printNota(p)" class="dropdown-item">
                        {{ p.numero_nota }} -
                        {{ p.tipo }}
                      </a>
                    </div>
                  </div>
                  <ng-template #elseBlockPrint1>
                    <button class="btn btn-outline-primary buttonMiddle nfe-btn" title="Nota fiscal" i18n-title
                      [class.spinner]="loadNota" [disabled]="!p.documentos || p.documentos.length ===0 || loadNota"
                      (click)="printNota(p.documentos[0])">
                      <img src="assets/nfe-icon.svg" class="normal-icon" width="24" />
                      <img src="assets/nfe-icon-hover.svg" class="hover-icon" width="24" />
                    </button>
                  </ng-template>
                  <button class="btn btn-outline-primary buttonMiddle" (click)="copyOrderFinalizada(p, 0)"
                    title="Copiar" i18n-title [class.spinner]="loadPdf" [disabled]="loadPdf">
                    <i class="icofont-copy"></i>
                  </button>
                  <button class="btn btn-outline-primary buttonMiddle" (click)="printPedidoPdf(p)" title="Imprimir"
                    i18n-title [class.spinner]="loadPdf" [disabled]="loadPdf">
                    <i class="icofont-printer"></i>
                  </button>
                  <button (click)="toHome()" *ngIf="page !== 'ABERTO'" title="Home"
                    class="btn btn-outline-primary buttonRight">
                    <mat-icon>home</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="pageable && !empty" class="row">
        <div class="col-lg-4 pl-0">
          <label i18n>Página {{ pageable.number + 1 }} de
            {{ pageable.totalPages }}</label>
        </div>
        <div class="col-lg-4">
          <pagination [totalItems]="pageable.totalElements" [maxSize]="5" [disabled]="pedidoService.loading"
            [(ngModel)]="pageNumber" (pageChanged)="pageChanged($event)" previousText="&lsaquo;" nextText="&rsaquo;">
          </pagination>
        </div>
        <div class="col-lg-4 text-right pr-0">
          <label i18n>{{ pageable.totalElements }} registros encontrados</label>
        </div>
      </div>
    </div>
  </div>
  <input type="text" id="inputLinkAprovaCliente" style="opacity: 0" />
</div>
<div class="modal fade" id="pedidoModal" tabindex="-1" role="dialog" aria-labelledby="pedidoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <!-- <div class="col-2">
          <h5 class="modal-title" i18n>Pedido #</h5>
        </div>
          <div class="col-10">
            <div *ngFor="let c of pedido.clientes" class="row">
              <h5>
                {{ c.id }}
              </h5>
            </div>
          </div> -->
        <h5 class="modal-title" i18n>ID #{{ pedido.id }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2">
          <div class="col-sm-5 pr-0">
            <label><input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected.todos"
                (change)="changePedidoClienteSelectedTodos()" />
              {{ SITE.labelCliente }}</label><br />
            <div *ngFor="let pc of pedido.clientes">
              <label style="font-size: inherit">
                <input type="checkbox" value="true" [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
                  (change)="changePedidoClienteSelected()" />
                {{ pc.cliente[SITE.identificacaoCliente] }} -
                {{ pc.cliente.nome }}, {{ pc.cliente.documento }}
              </label>
            </div>
          </div>
          <div class="col-sm-3 pr-0">
            <label>{{ SITE.labelFilial }}</label><br />
            {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
          </div>
          <div class="col-sm-3">
            <label>{{ SITE.labelTabela }}</label><br />
            {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
          </div>
          <button *ngIf="!this.initProvider.inicializaPedido" class="duplica-btn" title="duplicar pedido"
            style="border: none; background: transparent" (click)="duplicaPedidoDig(pedido)">
            <img src="assets/duplicate.svg" width="20" style="margin-right: 7px" />
          </button>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div *ngIf="pedido.data" class="col-sm-2">
            <label i18n>Data</label><br />
            {{ pedido.data }}
          </div>
          <div *ngIf="pedido.dataEntrega" class="col-sm-2">
            <label i18n>Data Entrega</label><br />
            {{ pedido.dataEntrega }}
          </div>
          <div class="col-sm-2">
            <label>Status</label><br />
            {{ pedido.status }}
          </div>
          <div class="col-sm-2">
            <label i18n>Quantidade</label><br />
            {{ quantidadeTotal }}
          </div>
          <div *ngIf="pedido.formaPagamento" class="col-sm-3">
            <label i18n>Forma pagamento</label><br />
            {{ pedido.formaPagamento.codigo }} -
            {{ pedido.formaPagamento.descricao }}
          </div>
          <div class="col-sm-3">
            <label i18n>Tipo</label><br />
            {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
          </div>
          <div *ngIf="pedido.pedido_cancelado" class="col-sm-2 mt-2 detalhe-cancelamento">
            <label i18n>Cancelamento</label><br />
            {{ pedido.nome_usuario_cancelou }}
          </div>
          <div *ngIf="pedido.pedido_cancelado" class="col-sm-2 mt-2 detalhe-cancelamento">
            <label i18n>Data Cancelado</label><br />
            {{ pedido.data_cancelado }}
          </div>
          <div *ngIf="pedido.pedido_finalizado" class="col-sm-2 mt-2 detalhe-finalizacao">
            <label i18n>Finalizou</label><br />
            {{ pedido.nome_usuario_finalizou}}
          </div>
          <div *ngIf="pedido.pedido_finalizado" class="col-sm-2 mt-2 detalhe-finalizacao">
            <label i18n>Data Finalização</label><br />
            {{ pedido.data_finalizado }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <div *ngIf="pedido.observacao">
              <label i18n>Observações</label><br />
              {{ pedido.observacao }}
            </div>
          </div>
          <div class="col-sm-6 pl-0">
            <div class="row mb-1 pl-0" *ngIf="this.SITE.mostraImpostoDetalhado">
              <div class="col-8 text-right pl-0" i18n>Subtotal:</div>
              <div class="col-4 pl-0" i18n>
                R$ {{ subTotal | currency : "BRL" : "" }}
              </div>
            </div>
            <div *ngIf="acrescimoTotal" class="row mb-1 pl-0">
              <div class="col-8 text-right" i18n>+ Acréscimos:</div>
              <div class="col-4">
                <span i18n>R$ {{ acrescimoTotal | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="descontoTotal" class="row mb-1 pl-0">
              <div class="col-8 text-right" i18n>- Descontos:</div>
              <div class="col-4">
                <span i18n>R$ {{ descontoTotal | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="impostosTotal && this.SITE.mostraImpostoDetalhado" class="row mb-1 pl-0" style="color: red">
              <div class="col-8 text-right" i18n>+ Impostos:</div>
              <div class="col-4">
                <span i18n>R$ {{ impostosTotal | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.freteValor" class="row mb-1" style="color: red">
              <div class="col-8 text-right" i18n>+ Frete:</div>
              <div class="col-4">
                <span i18n>R$ {{ pedido.freteValor | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0 ttt" i18n>Valor total:</div>
              <div class="col-4 pl-0" style="color: green; font-weight: bold" i18n>
                R$ {{ valorTotal | currency : "BRL" : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-5"></div>
          <div class="col-sm-7"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <!-- <div class="mt-2" [innerHtml]="tablePedidoAberto"></div> -->
            <div class="mt-2">
              <div *ngFor="let p of orderItens" class="table-responsive">
                <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
                  <thead class="table-head">
                    <tr>
                      <th colspan="5" style="font-size: 14px">
                        {{
                        p.produtoReferencia +
                        " - " +
                        (p.itens[0].produtoDescricao
                        ? p.itens[0].produtoDescricao
                        : p.itens[0].descricao)
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="product-details-tbody">
                    <tr class="product-details-tr-1">
                      <td class="text-start product-details-td-1" [style.width]="'20%'" i18n>
                        COR
                      </td>
                      <td class="text-start product-details-td-1" [style.width]="'20%'" i18n>
                        TAMANHO
                      </td>
                      <!-- <td class="text-start product-details-td-1">ESTAMPA</td> -->
                      <td class="text-start product-details-td-1" [style.width]="'20%'" i18n>
                        QTDE
                      </td>
                      <td class="text-start product-details-td-1" [style.width]="'20%'" i18n>
                        PREÇO
                      </td>
                      <td class="text-start product-details-td-1" [style.width]="'20%'">
                        TOTAL
                      </td>
                    </tr>
                    <tr class="product-details-tr-2" *ngFor="let i of p.itens">
                      <td class="product-details-td-2 text-start" [style.width]="'20%'">
                        {{ i.corDescricao }}
                      </td>
                      <td class="product-details-td-2 text-start" [style.width]="'20%'">
                        {{ i.tamanho }}
                      </td>
                      <!-- <td class="product-details-td-2 text-start" [style.width]="'20%'">{{i.estampaDescricao}}</td> -->
                      <td class="product-details-td-2 text-start" [style.width]="'20%'">
                        {{ i.quantidade }}
                      </td>
                      <td class="product-details-td-2 text-start" [style.width]="'20%'" i18n>
                        R$ {{ i.preco | currency : "BRL" : "" }}
                      </td>
                      <td class="product-details-td-2 text-start" [style.width]="'20%'" i18n>
                        R$ {{ i.total | currency : "BRL" : "" }}
                      </td>
                    </tr>
                    <tr class="product-details-td-3">
                      <td class="text-start" [style.width]="'20%'"></td>
                      <td class="text-start" [style.width]="'20%'"></td>
                      <td class="text-start" [style.width]="'20%'">
                        <b>
                          {{ sumQtd(p.itens) }}
                        </b>
                      </td>
                      <td class="text-start" [style.width]="'20%'"></td>
                      <td class="text-start" [style.width]="'20%'">
                        <b i18n>
                          R$
                          {{ sumPrc(p.itens) | currency : "BRL" : "" }}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="pedidoModalFinalizado" tabindex="-1" role="dialog" aria-labelledby="pedidoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div *ngIf="pedido && page != 'ABERTO'" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Pedido #{{
          pedido.numero_pedido ? pedido.numero_pedido : pedido.id_pedido
          }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2">
          <div *ngIf="page !== 'TODOS'" class="col-sm-6 pr-0">
            <label>{{ SITE.labelCliente }}</label><br />
            <!-- {{ pedido.cliente | json}} -->
            {{
            pedido.cliente
            ? pedido.cliente.clientefantasia +
            " - " +
            pedido.cliente.clientedocumento
            : pedido.clientes[0].cliente.clientefantasia +
            " - " +
            pedido.clientes[0].cliente.clientedocumento
            }}
          </div>
          <div class="col-sm-3 pr-0">
            <label>{{ SITE.labelFilial }}</label><br />
            {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
          </div>
          <div class="col-sm-2">
            <label>{{ SITE.labelTabela }}</label><br />
            {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
          </div>
          <div *ngIf="page === 'TODOS'" class="col-sm-6 pr-0"></div>
          <div class="col-sm-1">
            <button *ngIf="!this.initProvider.inicializaPedido" class="duplica-btn" title="duplicar pedido"
              style="border: none; background: transparent" (click)="duplicaPedido(pedido)">
              <img src="assets/duplicate.svg" width="20" style="margin-right: 7px" />
            </button>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-2">
            <label i18n>Data</label><br />
            {{ pedido.data }}
          </div>
          <div *ngIf="pedido.dataEntrega" class="col-sm-2">
            <label i18n>Data Entrega</label><br />
            {{ pedido.dataEntrega }}
          </div>
          <div class="col-sm-2">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-2">
            <label i18n>Quantidade</label><br />
            {{ pedido.quantidade }}
          </div>
          <div class="col-sm-3">
            <label i18n>Forma pagamento</label><br />
            {{ pedido.formaPagamento.codigo }} -
            {{ pedido.formaPagamento.descricao }}
          </div>
          <div class="col-sm-2 mt-2">
            <label i18n>Tipo</label><br />
            {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
          </div>
          <div class="col-sm-2 mt-2 mostra-cupom-detalhes">
            <label i18n>Cupom</label><br />
            {{ pedido.cupom_aplicado }}
          </div>
          <div *ngIf="pedido.pedido_cancelado" class="col-sm-2 mt-2 detalhe-cancelamento">
            <label i18n>Cancelamento</label><br />
            {{ pedido.nome_usuario_cancelou }}
          </div>
          <div *ngIf="pedido.pedido_cancelado" class="col-sm-2 mt-2 detalhe-cancelamento">
            <label i18n>Data Cancelado</label><br />
            {{ pedido.data_cancelado }}
          </div>
          <div *ngIf="pedido.pedido_finalizado" class="col-sm-2 mt-2 detalhe-finalizacao">
            <label i18n>Finalizou</label><br />
            {{ pedido.nome_usuario_finalizou}}
          </div>
          <div *ngIf="pedido.pedido_finalizado" class="col-sm-2 mt-2 detalhe-finalizacao">
            <label i18n>Data Finalização</label><br />
            {{ pedido.data_finalizado }}
          </div>
          <!-- <div class="col-sm-2 mt-2">
            <label i18n>Valor do Cupom</label><br />
            <span i18n>
              R$ {{ pedido.valor_desconto_cupom  | currency : "BRL" : "" }}
            </span>
          </div> -->
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <div *ngIf="pedido.observacao">
              <label i18n>Observações</label><br />
              {{ pedido.observacao }}
            </div>
          </div>
          <div class="col-sm-6 pl-0">
            <div class="row mb-1 pl-0" *ngIf="this.SITE.mostraImpostoDetalhado">
              <div class="col-8 text-right pl-0">Subtotal:</div>
              <div class="col-4 pl-0" i18n>
                R$ {{ pedido.subtotal | currency : "BRL" : "" }}
              </div>
            </div>
            <div *ngIf="pedido.acrescimo" class="row mb-1 pl-0" style="color: red">
              <div class="col-8 text-right" i18n>+ Acréscimos:</div>
              <div class="col-4">
                <span i18n>R$ {{ pedido.acrescimo | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.desconto" class="row mb-1 pl-0" style="color: blue">
              <div class="col-8 text-right" i18n>- Descontos:</div>
              <div class="col-4">
                <span i18n>R$ {{ pedido.desconto | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.valor_desconto_cupom" class="row mb-1 pl-0" style="color: blue">
              <div class="col-8 text-right" i18n>- Cupons:</div>
              <div class="col-4">
                <span i18n>R$
                  {{
                  pedido.valor_desconto_cupom | currency : "BRL" : ""
                  }}</span>
              </div>
            </div>
            <div *ngIf="pedido.impostos && this.SITE.mostraImpostoDetalhado" class="row mb-1 pl-0" style="color: red">
              <div class="col-8 text-right" i18n>+ Impostos:</div>
              <div class="col-4">
                <span i18n>R$ {{ pedido.impostos | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.freteValor" class="row mb-1" style="color: red">
              <div class="col-8 text-right" i18n>+ Frete:</div>
              <div class="col-4">
                <span i18n>R$ {{ pedido.freteValor | currency : "BRL" : "" }}</span>
              </div>
            </div>
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0 tes" i18n>Valor total:</div>
              <div class="col-4 pl-0" style="color: green; font-weight: bold" i18n>
                R$ {{ pedido.total | currency : "BRL" : "" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-5"></div>
          <div class="col-sm-7"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <!-- {{pedido.itens | json }} -->
            <!-- <div class="mt-2" [innerHtml]="tablePedidoView"></div> -->
            <div class="mt-2">
              <div *ngFor="let p of orderItens" class="table-responsive">
                <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
                  <thead class="table-head">
                    <tr>
                      <th colspan="5" style="font-size: 14px">
                        {{
                        p.produtoReferencia +
                        " - " +
                        (p.itens[0].produtoDescricao
                        ? p.itens[0].produtoDescricao
                        : p.itens[0].descricao)
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-start" i18n>COR</td>
                      <td class="text-start" i18n>TAMANHO</td>
                      <!-- <td class="text-start" i18n>ESTAMPA</td> -->
                      <td class="text-start" i18n>QTDE</td>
                      <td class="text-start" i18n>PREÇO</td>
                      <td class="text-start" i18n>TOTAL</td>
                    </tr>
                    <tr *ngFor="let i of p.itens">
                      <td class="text-start">{{ i.corDescricao }}</td>
                      <td class="text-start">{{ i.tamanho }}</td>
                      <!-- <td class="text-start">{{i.estampaDescricao}}</td> -->
                      <td class="text-start">{{ i.quantidade }}</td>
                      <td class="text-start" i18n>
                        R$ {{ i.preco | currency : "BRL" : "" }}
                      </td>
                      <td class="text-start" i18n>
                        R$ {{ i.total | currency : "BRL" : "" }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-start"></td>
                      <!-- <td class="text-start"></td> -->
                      <td class="text-start"></td>
                      <td class="text-start">
                        <b>
                          {{ sumQtd(p.itens) }}
                        </b>
                      </td>
                      <td class="text-start"></td>
                      <td class="text-start">
                        <b i18n>
                          R$
                          {{ sumPrc(p.itens) | currency : "BRL" : "" }}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--<div class="mt-2">
                          <simple-html [html]="tablePedidoView"></simple-html>
                      </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="pedidoModalInfo" tabindex="-1" role="dialog" aria-labelledby="pedidoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Pedido #{{ pedido.pedido }} - Informações
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2 row-id-erp">
          <div class="col-sm-4 pr-0">
            <label>Id ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].idErp }}
          </div>
          <div class="col-sm-8">
            <label i18n>Código ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].codigoErp }}
          </div>
        </div>
        <hr class="mt-2 mb-2 row-id-erp" />
        <div class="row mt-2 row-nfs">
          <div class="col-sm-4 pr-0">
            <label>NFS</label><br />
            {{ pedido.infos[pedido.infos.length - 1].nfs }}
          </div>
          <div class="col-sm-8">
            <label>Chave NFE</label><br />
            {{ pedido.infos[pedido.infos.length - 1].chaveNfe }}
          </div>
        </div>
        <hr class="mt-2 mb-2 row-nfs" />
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-8">
            <label i18n>Número Objeto</label><br />
            {{ pedido.infos[pedido.infos.length - 1].numeroObjeto }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-2">
            <div class="table-responsive">
              <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
                <thead class="table-head">
                  <tr>
                    <th><label i18n>Data</label></th>
                    <th><label i18n>Status</label></th>
                    <th><label i18n>NFS</label></th>
                    <th><label i18n>Chave NFE</label></th>
                    <th><label i18n>Número Objeto</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let info of pedido.infos">
                    <td>{{ info.data }}</td>
                    <td>{{ info.statusDescricao }}</td>
                    <td>{{ info.nfs }}</td>
                    <td style="font-size: 0.6rem">{{ info.chaveNfe }}</td>
                    <td>{{ info.numeroObjeto }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmDelModal" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente excluir?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="deletePedido()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmCopyModal" tabindex="-1" role="dialog" aria-labelledby="confirmDelModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente copiar este pedido?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button (click)="copyPedido()" type="button" data-dismiss="modal" class="btn btn-outline-primary">
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="printPedidoModal" tabindex="-1" role="dialog" aria-labelledby="boletoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="pedido" class="modal-title" i18n>
          Pedido #{{ pedido.pedido }}
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body"></div>
    </div>
  </div>
</div>
<div class="modal fade" id="pixModal" tabindex="-1" role="dialog" aria-labelledby="pixModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>QR code de pagamento</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body col mx-auto text-center">
        <img width="200" height="200" [src]="getSafeImageUrl()" />
        <span class="copy-btn" (click)="copyLink(qrCode.codigo_qrcode)">
          {{ qrCode.codigo_qrcode }}
        </span>

        <br />
        <button class="btn btn-success mt-2 mr-2 mb-2" (click)="copyLink(qrCode.codigo_qrcode)">
          Copiar código
        </button>
      </div>
      <!-- <div class="modal-footer">
        <button
          (click)="removeItem()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div> -->
    </div>
  </div>
</div>